import HeaderSimple from "../HeaderSimple/HeaderSimple.vue"
import ResponsiveFooter from "../responsivefooter/ResponsiveFooter.vue"
import axios from 'axios';
import spinner from "../LoadingComponent/LoadingComponent.vue"
import CookieLaw from 'vue-cookie-law'
import SideBar from "../SideBar/SideBar.vue"
var domain = "https://user.sigmafolio.net/"

export default {
  name: 'loginpage',
  components: {
    HeaderSimple,
    responsivefooter: ResponsiveFooter,
    spinner,
    CookieLaw,
    SideBar
  },
  props: [],
  data () {
    return {
      showSpinner: false,
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    login: async function(){
      this.showSpinner = true;
      var email = document.getElementById("email").value;
      var password = document.getElementById("password").value;
      if (email != "" & password != ""){
        console.log(domain);
        await this.retrieveToken( domain + "api/token/", email, password)

        }
      else{      
        alert("Bitte gib sowohl deine Email-Adresse als auch dein Passwort ein.")
      }
    }
      
,

    retrieveToken: async function(url, email,password){
      axios.post(url, {
        // password send unencrypted!
        username: email,
        password: password
      }
      ).then(response => {

        localStorage.setItem('access-token', response.data["access"]) // store the token in localstorage
        localStorage.setItem('refresh-token', response.data["refresh"]) // store the token in localstorage
        console.log("token saved.", localStorage.getItem('access-token', response.data["access"]));

        console.log("pushed");
        this.$router.push("/portfolios");
        console.log("finished");
        return true
      }).catch(e => {
        console.log(e);
        this.showSpinner = false;
        alert("Email oder Passwort ist nicht korrekt. Bitte versuche es erneut.")
        return false;
      })
    },


  }
}


